<h1 class="text-center">
  {{ 'CURRENT_PROBLEMS_IN_PROCESS' | translate }}
</h1>

<p class="mt-0 mb-4 font-size-16 color-grey-desc text-center app-dashboard-slogan">
  {{ 'DASHBOARD_INFO' | translate }}
</p>

<dx-accordion
  [dataSource]="problems"
  [collapsible]="true"
  [multiple]="true"
  [selectedIndex]="null"
  [animationDuration]="300"
  (onItemTitleClick)="onItemTitleClick($event)"
  class="accordion-new mb-2">
  <div *dxTemplate="let problem of 'title'">
    <div class="accordion-row accordion-row-dashboard justify-content-between align-items-center">
      <div class="mb-xl-0 mb-2">
        <div class="font-size-13 color-grey-label">{{ 'DATE_PUBLICATION' | translate }}</div>
        <div class="d-flex align-items-center">
          <span class="me-2 font-size-16 color-green-dark letter-spacing-1 font-weight-middle">
            {{ problem.publishDate | date: 'HH:mm dd-MM-yyyy' }}
          </span>
          <span class="mdi mdi-calendar-month color-green-dark font-size-26"></span>
        </div>
      </div>

      <div class="mb-xl-0 mb-2 font-size-18-em font-weight-middle line-height-1-7">
        {{ problem.title }}
      </div>

      <div class="mb-xl-0 mb-2">
        <div class="font-size-13 color-grey-label">{{ 'TIME_ELIMINATION' | translate }}</div>
        <div class="d-flex align-items-center">
          <span class="me-2 font-size-16 color-green-dark letter-spacing-1 font-weight-middle">
            {{ getTimeLeft(problem) }}
          </span>
          <span class="mdi mdi-clock-time-nine-outline color-green-dark font-size-26"></span>
        </div>
      </div>

      <div class="align-self-center">
        @if (!problem.subscriptionId) {
          <dx-button text="{{ 'REPORT_DECISION' | translate }}" (onClick)="subscribeToProblem($event, problem.id)" class="btn"></dx-button>
        }
        @if (problem.subscriptionId) {
          <dx-button
            text="{{ 'UNREPORT_DECISION' | translate }}"
            (onClick)="unSubscribeToProblem($event, problem.subscriptionId)"
            class="btn btn-light"></dx-button>
        }
      </div>
    </div>
  </div>
  <div *dxTemplate="let problem of 'item'">
    <div class="d-flex dx-item-content-block">
      <div>
        @if (problem.image) {
          <img [src]="convertImage(problem)" style="width: 100px" />
        }
      </div>
      <div>{{ problem.description }}</div>
    </div>
  </div>
</dx-accordion>

<dx-button
  icon="mdi mdi-information-outline mdi-24px"
  text="{{ 'MY_PROBLEM_NOT_IN_LIST' | translate }}"
  (onClick)="goToSelfDiagnosticPage()"
  class="btn btn-green btn-big"></dx-button>
